import React, { useEffect } from "react";

const Dashboard: React.FC = () => {
  // Empty canvas for your real widgets/components
  return <div className="h-full w-full overflow-auto p-4" />;
};


export default Dashboard;